define("checkout/components/payment/address", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/runloop", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _runloop, _service, _utils, _component2, _tracking, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/runloop",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.addressCollectionEnabled}}
    <div
      class="u--block u--clearfix u--m__b u--m__t__md"
      data-test-id="address-checkout"
      id="e--addressCheckout"
      {{did-insert this.getAddress}}
    >
      {{#if this.showLoadingSpinner}}
        <div class="o--blank u--p__tb__lg">
          <p class="o--blank__desc u--text--center">{{t "account.subscription.billing.address.loading_message"}}</p>
          <div class="o--blank__img u--relative u--p__lg">
            <Shared::LoadingSpinner />
          </div>
        </div>
      {{else if this.showEditAddress}}
        <form {{on "submit" (perform this.confirm)}}>
          <Shared::ConfigurableAddressFields
            @isDisabled={{this.isEditDisabled}}
            @narrow={{true}}
            @setSelectedCountry={{this.setSelectedCountry}}
            @setSelectedState={{this.setSelectedState}}
            @setSuggestion={{this.setSuggestion}}
            @showErrors={{this.hasAttemptedSave}}
            @showFullForm={{this.showFullForm}}
            @showSuggestion={{false}}
            @values={{this.addressFields}}
            class="tCH--formWrapper"
          />
  
          {{#if this.showFullForm}}
            <Shared::Ui::Button
              @isDisabled={{or this.isSaveDisabled @isDisabled}}
              @text={{t "account.subscription.billing.address.save"}}
              @variant="default"
              class="tCH--btn--primary o--btn--block u--float--right qa--confirm_save_address__btn"
              data-test-id="confirm-button"
              type="submit"
            />
          {{/if}}
        </form>
      {{else if this.showAddressConfirmation}}
        {{#if this.showSuggestedAddress}}
          <form {{on "submit" (perform this.saveAddress)}}>
            <Shared::AddressFields::Suggestions
              @enteredAddress={{this.address.unsavedAddress}}
              @handleChange={{this.handleSuggestionChange}}
              @isDisabled={{@isDisabled}}
              @setEditingAddress={{@setEditingAddress}}
              @suggestedAddress={{this.address.suggestedAddress}}
            />
          </form>
        {{else}}
          <label class="u--m__b__xs {{@qaClassInputLabel}}" data-test-id="shipping-address">
            {{t "account.subscription.billing.address.title"}}
          </label>
          <p class="u--text--sm u--text--light u--m__b" data-test-id="address-tax-text">
            {{t "account.subscription.billing.address.description"}}
          </p>
          <fieldset class="tCK--suggestionsWrapper">
            <p class="tCK--suggestions__title">
              {{svg-jar "warning" class="o--icon"}}
              {{t "account.subscription.billing.address.confirm.title_no_suggestion"}}
            </p>
            <p class="u--m__b">{{t "account.subscription.billing.address.confirm.description_no_suggestion"}}</p>
            {{! Entered Address }}
            <div class="tCK--suggestionsCard" data-test-id="saved-address">
              <label class="tCK--suggestionsCard__label" for="unsavedAddress">
                {{t "account.subscription.billing.address.entered_address"}}
                <span class="u--text--base" data-test-id="address">{{this.address.unsavedAddress}}</span>
              </label>
              <Shared::Ui::Button
                @isDisabled={{@isDisabled}}
                @onClick={{@setEditingAddress}}
                @text={{t "shared_words.edit"}}
                @variant="outline"
                aria-label={{t "shared_words.edit"}}
                data-test-id="edit-address-button"
              />
            </div>
            <Shared::Ui::Button
              @text={{t "account.subscription.billing.address.confirm.cta"}}
              @variant="default"
              aria-label={{t "account.subscription.billing.address.confirm.cta"}}
              class="tCH--btn--primary o--btn--block u--m__t qa--confirm_save_address__btn"
              data-test-id="save-button"
              {{on "click" (perform this.saveAddress)}}
            />
          </fieldset>
        {{/if}}
      {{else}}
        <div class="u--row u--row--noCollapse" data-test-id="saved-address">
          <div class="u--col__8">
            <p class="u--text--bold u--m__b__xs">{{t "account.subscription.billing.address.title"}}</p>
            <span data-test-id="address">
              {{this.address.completedAddress}}
            </span>
          </div>
          <div class="u--col__4 u--text--right">
            <Shared::Ui::Button
              @isDisabled={{@isDisabled}}
              @onClick={{@setEditingAddress}}
              @text={{t "shared_words.edit"}}
              @variant="outline"
              data-test-id="edit-address-button"
            />
          </div>
          {{#unless this.isSavedAddressVerified}}
            <div class="u--col__12">
              <p class="u--text--sm u--text--light u--m__t__xs">
                {{svg-jar "info" class="o--icon--sm"}}
                {{t "account.subscription.billing.address.confirm.disclaimer"}}
              </p>
            </div>
          {{/unless}}
        </div>
      {{/if}}
    </div>
  {{/if}}
  */
  {
    "id": "AIneTDPO",
    "block": "[[[41,[30,0,[\"addressCollectionEnabled\"]],[[[1,\"  \"],[11,0],[24,0,\"u--block u--clearfix u--m__b u--m__t__md\"],[24,\"data-test-id\",\"address-checkout\"],[24,1,\"e--addressCheckout\"],[4,[38,1],[[30,0,[\"getAddress\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"showLoadingSpinner\"]],[[[1,\"      \"],[10,0],[14,0,\"o--blank u--p__tb__lg\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"o--blank__desc u--text--center\"],[12],[1,[28,[35,2],[\"account.subscription.billing.address.loading_message\"],null]],[13],[1,\"\\n        \"],[10,0],[14,0,\"o--blank__img u--relative u--p__lg\"],[12],[1,\"\\n          \"],[8,[39,3],null,null,null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showEditAddress\"]],[[[1,\"      \"],[11,\"form\"],[4,[38,4],[\"submit\",[28,[37,5],[[30,0,[\"confirm\"]]],null]],null],[12],[1,\"\\n        \"],[8,[39,6],[[24,0,\"tCH--formWrapper\"]],[[\"@isDisabled\",\"@narrow\",\"@setSelectedCountry\",\"@setSelectedState\",\"@setSuggestion\",\"@showErrors\",\"@showFullForm\",\"@showSuggestion\",\"@values\"],[[30,0,[\"isEditDisabled\"]],true,[30,0,[\"setSelectedCountry\"]],[30,0,[\"setSelectedState\"]],[30,0,[\"setSuggestion\"]],[30,0,[\"hasAttemptedSave\"]],[30,0,[\"showFullForm\"]],false,[30,0,[\"addressFields\"]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"showFullForm\"]],[[[1,\"          \"],[8,[39,7],[[24,0,\"tCH--btn--primary o--btn--block u--float--right qa--confirm_save_address__btn\"],[24,\"data-test-id\",\"confirm-button\"],[24,4,\"submit\"]],[[\"@isDisabled\",\"@text\",\"@variant\"],[[28,[37,8],[[30,0,[\"isSaveDisabled\"]],[30,1]],null],[28,[37,2],[\"account.subscription.billing.address.save\"],null],\"default\"]],null],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showAddressConfirmation\"]],[[[41,[30,0,[\"showSuggestedAddress\"]],[[[1,\"        \"],[11,\"form\"],[4,[38,4],[\"submit\",[28,[37,5],[[30,0,[\"saveAddress\"]]],null]],null],[12],[1,\"\\n          \"],[8,[39,9],null,[[\"@enteredAddress\",\"@handleChange\",\"@isDisabled\",\"@setEditingAddress\",\"@suggestedAddress\"],[[30,0,[\"address\",\"unsavedAddress\"]],[30,0,[\"handleSuggestionChange\"]],[30,1],[30,2],[30,0,[\"address\",\"suggestedAddress\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,\"label\"],[15,0,[29,[\"u--m__b__xs \",[30,3]]]],[14,\"data-test-id\",\"shipping-address\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"account.subscription.billing.address.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--text--sm u--text--light u--m__b\"],[14,\"data-test-id\",\"address-tax-text\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"account.subscription.billing.address.description\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"fieldset\"],[14,0,\"tCK--suggestionsWrapper\"],[12],[1,\"\\n          \"],[10,2],[14,0,\"tCK--suggestions__title\"],[12],[1,\"\\n            \"],[1,[28,[35,10],[\"warning\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n            \"],[1,[28,[35,2],[\"account.subscription.billing.address.confirm.title_no_suggestion\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,2],[14,0,\"u--m__b\"],[12],[1,[28,[35,2],[\"account.subscription.billing.address.confirm.description_no_suggestion\"],null]],[13],[1,\"\\n\"],[1,\"          \"],[10,0],[14,0,\"tCK--suggestionsCard\"],[14,\"data-test-id\",\"saved-address\"],[12],[1,\"\\n            \"],[10,\"label\"],[14,0,\"tCK--suggestionsCard__label\"],[14,\"for\",\"unsavedAddress\"],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"account.subscription.billing.address.entered_address\"],null]],[1,\"\\n              \"],[10,1],[14,0,\"u--text--base\"],[14,\"data-test-id\",\"address\"],[12],[1,[30,0,[\"address\",\"unsavedAddress\"]]],[13],[1,\"\\n            \"],[13],[1,\"\\n            \"],[8,[39,7],[[16,\"aria-label\",[28,[37,2],[\"shared_words.edit\"],null]],[24,\"data-test-id\",\"edit-address-button\"]],[[\"@isDisabled\",\"@onClick\",\"@text\",\"@variant\"],[[30,1],[30,2],[28,[37,2],[\"shared_words.edit\"],null],\"outline\"]],null],[1,\"\\n          \"],[13],[1,\"\\n          \"],[8,[39,7],[[16,\"aria-label\",[28,[37,2],[\"account.subscription.billing.address.confirm.cta\"],null]],[24,0,\"tCH--btn--primary o--btn--block u--m__t qa--confirm_save_address__btn\"],[24,\"data-test-id\",\"save-button\"],[4,[38,4],[\"click\",[28,[37,5],[[30,0,[\"saveAddress\"]]],null]],null]],[[\"@text\",\"@variant\"],[[28,[37,2],[\"account.subscription.billing.address.confirm.cta\"],null],\"default\"]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]]],[]],[[[1,\"      \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[14,\"data-test-id\",\"saved-address\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"u--col__8\"],[12],[1,\"\\n          \"],[10,2],[14,0,\"u--text--bold u--m__b__xs\"],[12],[1,[28,[35,2],[\"account.subscription.billing.address.title\"],null]],[13],[1,\"\\n          \"],[10,1],[14,\"data-test-id\",\"address\"],[12],[1,\"\\n            \"],[1,[30,0,[\"address\",\"completedAddress\"]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"u--col__4 u--text--right\"],[12],[1,\"\\n          \"],[8,[39,7],[[24,\"data-test-id\",\"edit-address-button\"]],[[\"@isDisabled\",\"@onClick\",\"@text\",\"@variant\"],[[30,1],[30,2],[28,[37,2],[\"shared_words.edit\"],null],\"outline\"]],null],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[51,[30,0,[\"isSavedAddressVerified\"]]],[[[1,\"          \"],[10,0],[14,0,\"u--col__12\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--text--sm u--text--light u--m__t__xs\"],[12],[1,\"\\n              \"],[1,[28,[35,10],[\"info\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n              \"],[1,[28,[35,2],[\"account.subscription.billing.address.confirm.disclaimer\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]],[]]]],[]]],[1,\"  \"],[13],[1,\"\\n\"]],[]],null]],[\"@isDisabled\",\"@setEditingAddress\",\"@qaClassInputLabel\"],false,[\"if\",\"did-insert\",\"t\",\"shared/loading-spinner\",\"on\",\"perform\",\"shared/configurable-address-fields\",\"shared/ui/button\",\"or\",\"shared/address-fields/suggestions\",\"svg-jar\",\"unless\"]]",
    "moduleName": "checkout/components/payment/address.hbs",
    "isStrictMode": false
  });
  let PaymentAddressComponent = _exports.default = (_class = class PaymentAddressComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "address", _descriptor, this);
      _initializerDefineProperty(this, "alerts", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "stripe", _descriptor4, this);
      _initializerDefineProperty(this, "hasAttemptedSave", _descriptor5, this);
      _initializerDefineProperty(this, "showEdit", _descriptor6, this);
      _initializerDefineProperty(this, "showLoadingSpinner", _descriptor7, this);
      _initializerDefineProperty(this, "selectedAddressOption", _descriptor8, this);
      _defineProperty(this, "saveAddress", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (event) {
          event.preventDefault();
          const addressToSave = this.selectedAddressOption === 'suggested' ? this.address.suggestedAddressFields : this.addressFields;
          try {
            yield this.address.save.perform(addressToSave);
            this.address.trackSavedSuccessfully(addressToSave, 'checkout');
          } catch ({
            alert
          }) {
            this.alerts.warning(this.intl.t('account.subscriptions.billing.address'));
          }
        }
      }), null, "saveAddress", null));
      _defineProperty(this, "confirm", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (event) {
          event.preventDefault();
          this.hasAttemptedSave = true;
          this.address.trackClickedSave(this.addressFields, 'checkout');

          // Note: If validation is rate limiting, this might take longer than expected. We want to show a loading state when retrying.
          (0, _runloop.later)(() => {
            if (this.address.validateAddress.isRunning) {
              this.showLoadingSpinner = true;
              this.address.trackViewedLoadingSpinner(this.addressFields, 'checkout');
            }
          }, this.address.DEFAULT_LOADING_STATE_THRESHOLD_IN_MS);
          try {
            if (!this.address.hasRequiredFields(this.addressFields)) {
              return;
            }
            const isAddressValid = yield this.address.validateAddress.perform(this.addressFields);
            if (!isAddressValid) {
              this.address.trackViewedValidationError(this.addressFields, 'checkout');
              this.args.hideEditingAddress();
              this.selectedAddressOption = this.showSuggestedAddress ? 'suggested' : 'entered';
              return;
            }
            yield this.address.save.perform(this.addressFields);
            this.address.trackSavedSuccessfully(this.addressFields, 'checkout');
            this.alerts.success(this.intl.t('alerts.account.address.success.message'), {
              title: this.intl.t('alerts.account.address.success.title')
            });
            this.args.hideEditingAddress();
          } catch ({
            alert
          }) {
            this.address.trackViewedServerError(this.addressFields, 'checkout');
            this.alerts.add(alert);
          } finally {
            this.showLoadingSpinner = false;
          }
        }
      }), null, "confirm", "drop"));
    }
    get addressCollectionEnabled() {
      const hideForWallets = this.stripe.isWalletSelected && !this.hasUnsavedChanges && !this.address.isSavedAddressValid;
      return this.address.addressCollectionEnabled && !hideForWallets;
    }
    get showAddressConfirmation() {
      return !this.address.isUnsavedAddressVerified && this.hasUnsavedChanges;
    }
    get isSavedAddressVerified() {
      return this.address.isSavedAddressVerified;
    }
    get isEditDisabled() {
      //Note: country is set automatically when credit card is added/updated.
      const requiresCountryFromCard = !this.address.unsavedAddressFields.country;
      return this.confirm.isRunning || requiresCountryFromCard;
    }
    get isSaveDisabled() {
      return this.hasAttemptedSave && !this.address.hasRequiredFields(this.addressFields);
    }
    get showSuggestedAddress() {
      return (0, _utils.isPresent)(this.address.suggestedChanges) && this.address.isSuggestedAddressValid;
    }
    get showEditAddress() {
      return this.args.isEditingAddress;
    }
    get showFullForm() {
      return this.address.isFullAddressRequired;
    }
    get addressFields() {
      return this.address.unsavedAddressFields;
    }
    get hasUnsavedChanges() {
      return this.address.hasUnsavedChanges;
    }
    getAddress() {
      //Note: saved address may not be valid if no address exists
      // unsaved address can be invalid if state field is unset when address is loaded (when we added the state dropdown options)
      if (!this.address.isSavedAddressValid || !this.address.hasRequiredFields(this.address.unsavedAddressFields)) {
        this.args.setEditingAddress();
      }
    }
    setSelectedCountry(country) {
      this.address.setSelectedCountry(country);
    }
    setSelectedState(state) {
      this.address.setFieldValue('state', state);
    }
    setSuggestion(addressField, suggestedValue) {
      this.address.setFieldValue(addressField, suggestedValue);
    }
    handleSuggestionChange(address) {
      this.selectedAddressOption = address;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "stripe", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "hasAttemptedSave", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "showEdit", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "showLoadingSpinner", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "selectedAddressOption", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "getAddress", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "getAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSelectedCountry", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedCountry"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSelectedState", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSuggestion", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setSuggestion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleSuggestionChange", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleSuggestionChange"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PaymentAddressComponent);
});